<template>
  <div class="home">
    <Header />
    <div class="container py-5">
      <div class="text-center mb-5">
        <h1 class="fw-bold">Dashboard kulawarga</h1>
        <p class="text-muted">Pilih anggota kulawarga kanggo ngatur cathetan lan profil</p>
      </div>
      
      <div class="row justify-content-center g-4">
        <!-- Ayah -->
        <div class="col-md-4 col-lg-3">
          <div class="card h-100 text-center p-3 border-0 shadow-sm hover-card">
            <div class="card-body">
              <div class="avatar-wrapper mb-3 mx-auto">
                <img src="/img/bapak.png" class="rounded-circle shadow-sm avatar-img" alt="Ayah" />
              </div>
              <h4 class="card-title fw-bold mb-3">Ayah</h4>
              <div class="d-grid gap-2">
                <router-link :to="{ name: 'Akun', params: { orangnya: 'bapak' }}" class="btn btn-outline-primary btn-sm">
                  <i class="bi bi-person me-1"></i> Profile
                </router-link>
                <router-link to="/ayah/notes" class="btn btn-primary btn-sm">
                  <i class="bi bi-journal-text me-1"></i> Notes
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <!-- Mama -->
        <div class="col-md-4 col-lg-3">
          <div class="card h-100 text-center p-3 border-0 shadow-sm hover-card">
            <div class="card-body">
              <div class="avatar-wrapper mb-3 mx-auto">
                <img src="/img/mama.png" class="rounded-circle shadow-sm avatar-img" alt="Mama" />
              </div>
              <h4 class="card-title fw-bold mb-3">Mama</h4>
              <div class="d-grid gap-2">
                <router-link :to="{ name: 'Akun', params: { orangnya: 'mama' }}" class="btn btn-outline-primary btn-sm">
                  <i class="bi bi-person me-1"></i> Profile
                </router-link>
                <router-link to="/mama/notes" class="btn btn-primary btn-sm">
                  <i class="bi bi-journal-text me-1"></i> Notes
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <!-- Rizal -->
        <div class="col-md-4 col-lg-3">
          <div class="card h-100 text-center p-3 border-0 shadow-sm hover-card">
            <div class="card-body">
              <div class="avatar-wrapper mb-3 mx-auto">
                <img src="/img/rizal.png" class="rounded-circle shadow-sm avatar-img" alt="Rizal" />
              </div>
              <h4 class="card-title fw-bold mb-3">Rizal</h4>
              <div class="d-grid gap-2">
                <router-link :to="{ name: 'Akun', params: { orangnya: 'rizal' }}" class="btn btn-outline-primary btn-sm">
                  <i class="bi bi-person me-1"></i> Profile
                </router-link>
                <router-link to="/rizal/notes" class="btn btn-primary btn-sm">
                  <i class="bi bi-journal-text me-1"></i> Notes
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'

export default {
  name: 'Home',
  components: {
    Header
  }
}
</script>

<style scoped>
.avatar-img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border: 4px solid var(--card-bg);
}

.hover-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.hover-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
}
</style>
